<template>
  <div>
    <el-table :data="tableData" :span-method="spanMethod" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
      <el-table-column prop="date" label="检查项" align="center">
        <el-table-column prop="orderIndex" label="" :width="80" align="center"> </el-table-column>
        <el-table-column prop="categoryName" label="" align="left">
          <template #default="scope">
            <span v-if="scope.row.categoryName == '车辆信息'">{{ scope.row.categoryName }}</span>
            <div v-else
              >采摘批次<div>{{ bizNo }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="" align="left">
         </el-table-column>
      </el-table-column>
      <el-table-column label="检查结果" align="center">
        <el-table-column prop="name" label="是否达标" align="center">
          <template #default="scope">
            <el-switch disabled :value="scope.row.isApproved"></el-switch> 
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="不达标原因" align="center"> </el-table-column>
      </el-table-column>
    </el-table>

    <!-- <table class="receipt-table">
      <thead>
        <tr>
          <th rowspan="2" colspan="3">检查项</th>
          <th colspan="2">检查结果</th>
        </tr>
        <tr>
          <th>是否达标</th>
          <th>不达标原因</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="2">1</td>
          <td rowspan="2" class="text-left">车辆信息</td>
          <td class="text-left">{{ licensePlateForm.content }}</td>
          <td><el-switch disabled :value="licensePlateForm.isApproved"> </el-switch></td>
          <td>{{ licensePlateForm.reason }}</td>
        </tr>
        <tr>
          <td class="text-left">{{ lockForm.content }}</td>
          <td><el-switch disabled :value="lockForm.isApproved"> </el-switch></td>
          <td>{{ lockForm.reason }}</td>
        </tr>
        <tr>
          <td rowspan="9">2</td>
          <td rowspan="9" class="text-left">
            <div style="margin-bottom: 10px">采摘批次</div>
            <div>{{ bizNo }}</div>
          </td>
          <td class="text-left">{{ quantityForm.content }}</td>
          <td><el-switch disabled :value="quantityForm.isApproved"> </el-switch></td>
          <td>{{ quantityForm.reason }}</td>
        </tr>
        <tr>
          <td class="text-left">{{ weightForm.content }}</td>
          <td><el-switch disabled :value="weightForm.isApproved"> </el-switch></td>
          <td>{{ weightForm.reason }}</td>
        </tr>
        <tr>
          <td class="text-left">{{ tareWeightForm.content }}</td>
          <td><el-switch disabled :value="tareWeightForm.isApproved"> </el-switch></td>
          <td>{{ tareWeightForm.reason }}</td>
        </tr>
        <tr>
          <td class="text-left">{{ totalWeightForm.content }}</td>
          <td><el-switch disabled :value="totalWeightForm.isApproved"> </el-switch></td>
          <td>{{ totalWeightForm.reason }}</td>
        </tr>
        <tr>
          <td class="text-left">质量是否达标</td>
          <td><el-switch disabled :value="massForm.isApproved"> </el-switch></td>
          <td>{{ massForm.reason }}</td>
        </tr>
      </tbody>
    </table> -->
  </div>
</template>
<script>
export default {
  name: 'ReceiptTable',
  props: {
    checkItems: {
      type: Array,
      default: () => [],
    },
    bizNo: {
      type: String,
      default: '',
    },
  },
  computed: {
    licensePlateForm() {
      const { content, isApproved, reason } = this.findItem('车牌号')
      return {
        content,
        isApproved,
        reason,
      }
    },
    lockForm() {
      const { content, isApproved, reason } = this.findItem('锁号')
      return {
        content,
        isApproved,
        reason,
      }
    },
    quantityForm() {
      const { content, isApproved, reason } = this.findItem('总筐数')
      return {
        content,
        isApproved,
        reason,
      }
    },
    weightForm() {
      const { content, isApproved, reason } = this.findItem('总重量')
      return {
        content,
        isApproved,
        reason,
      }
    },
    tareWeightForm() {
      const { content, isApproved, reason } = this.findItem('总皮重')
      return {
        content,
        isApproved,
        reason,
      }
    },
    totalWeightForm() {
      const { content, isApproved, reason } = this.findItem('总果重')
      return {
        content,
        isApproved,
        reason,
      }
    },
    massForm() {
      const { content, isApproved, reason } = this.findItem('质量是否达标')
      return {
        content,
        isApproved,
        reason,
      }
    },
  },
  data() {
    return {
      value: '',

      colLists: [
        {
          label: '检查项',
          prop: 'content',
          isTrue: true,
          children: [
            {
              label: '',
              prop: 'orderIndex',
              isTrue: true,
            },
            {
              label: '',
              prop: 'categoryName',
              isTrue: true,
              formSolt: true,
            },
            {
              label: '',
              prop: 'content',
              isTrue: true,
            },
          ]
        },
        {
          label: '检查结果',
          prop: '',
          isTrue: true,
          children: [
            {
              label: '是否达标',
              prop: 'isApproved',
              isTrue: true,
              formSolt: true,
            },
            {
              label: '不达标原因',
              prop: 'reason',
              isTrue: true,
            },
          ],
        },
      ],

      tableData: [],
    }
  },
  watch: {
    checkItems: {
      handler(list) {
        if (!list) return
        this.tableData = JSON.parse(JSON.stringify(list)).map((item, index) => {
          if (index === 0) {
            item.orderIndex = 1 
          } else {
            item.orderIndex = 2
          }

          item.isApproved = item.isApproved === 1 ? true : false
          return item
          
        }) || []
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    findItem(content) {
      const item = this.checkItems && JSON.parse(JSON.stringify(this.checkItems))?.find((item) => item.content.indexOf(content) > -1) || {}
      item.isApproved = item.isApproved === 1 ? true : false
      return item
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 0) {
      //   return [1, 3]
      // }
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex == 0) {
          return {
            rowspan: 2,
            colspan: 1,
          }
        } else if (rowIndex === 1) {
          return {
            rowspan: 0,
            colspan: 0,
          }
        } else if ((rowIndex - 2) % 5 === 0) {
          return {
            rowspan: 5,
            colspan: 1,
          }
        } else if ((rowIndex - 2) % 5 > 0 && (rowIndex - 2) % 5 < 6) {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 1 && (columnIndex === 0 || columnIndex === 1 || columnIndex === 2)) {
        //这里为了是将第二列的表头隐藏，就形成了合并表头的效果
        // document.querySelector(`.${column.id}`).setAttribute("colspan", "1");
        return { display: 'none' }
      }
      if (rowIndex === 0 && columnIndex === 0) {
        this.$nextTick(() => {
          document.querySelector(`.${column.id}`).setAttribute('rowspan', '3')
        })
        //这里为了是将第二列的表头隐藏，就形成了合并表头的效果
        // document.querySelector(`.${column.id}`).setAttribute("rowspan", "3");
      }

      return {
        background: '#fff',
        fontSize: '16px',
        color: '#000',
        padding: '10px 0px',
        fontWeight: 'normal',
      }
    },
    cellStyle(){
      return { color: '#000', padding: '10px 5px' }
    }
  },
}
</script>
<style lang="less" scoped>
.receipt-table {
  width: 100%;
  border-collapse: collapse;
  border-right: 1px solid #ccc;
  border-top: 1px solid #ccc;
  background-color: #fff;
  th {
    font-weight: normal;
  }
  th,
  td {
    padding: 10px;
    text-align: center;
    font-size: 16px;
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }

  .text-left {
    text-align: left;
  }
}
</style>
